import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4dc2c8a9"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "transcode-params-warp"
};
import TranscodeParamItem from '../components/TranscodeParamItem.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const getDefaultRatio = () => {
      return [{
        value: '3840*2460',
        label: '3840*2460'
      }, {
        value: '2560*1440',
        label: '2560*1440'
      }, {
        value: '1920*1080',
        label: '1920*1080'
      }, {
        value: '1280*720',
        label: '1280*720'
      }, {
        value: '854*480',
        label: '854*480'
      }, {
        value: '480*270',
        label: '480*270'
      }];
    };

    const getDefaultH264 = () => {
      return [{
        value: '8000',
        label: '8000'
      }, {
        value: '7000',
        label: '7000'
      }, {
        value: '3000',
        label: '3000'
      }, {
        value: '1000',
        label: '1000'
      }, {
        value: '600',
        label: '600'
      }, {
        value: '300',
        label: '300'
      }];
    };

    const getDefaultH265 = () => {
      return [{
        value: '5600',
        label: '5600'
      }, {
        value: '4900',
        label: '4900'
      }, {
        value: '2100',
        label: '2100'
      }, {
        value: '700',
        label: '700'
      }, {
        value: '500',
        label: '500'
      }, {
        value: '200',
        label: '200'
      }];
    };

    const transcodeParamData = ref([{
      title: '4K视频转码参数设置',
      formData: {
        ratio: '3840*2160',
        h264: '8000',
        h265: '5600'
      },
      selectOptinsObj: {
        ratio: getDefaultRatio(),
        h264: getDefaultH264(),
        h265: getDefaultH265()
      }
    }, {
      title: '2K视频转码参数设置',
      formData: {
        ratio: '2560*1440',
        h264: '7000',
        h265: '4900'
      },
      selectOptinsObj: {
        ratio: getDefaultRatio(),
        h264: getDefaultH264(),
        h265: getDefaultH265()
      }
    }, {
      title: '超清视频转码参数设置',
      formData: {
        ratio: '1920*1080',
        h264: '3000',
        h265: '2100'
      },
      selectOptinsObj: {
        ratio: getDefaultRatio(),
        h264: getDefaultH264(),
        h265: getDefaultH265()
      }
    }, {
      title: '高清视频转码参数设置',
      formData: {
        ratio: '1280*720',
        h264: '1000',
        h265: '700'
      },
      selectOptinsObj: {
        ratio: getDefaultRatio(),
        h264: getDefaultH264(),
        h265: getDefaultH265()
      }
    }, {
      title: '标清视频转码参数设置',
      formData: {
        ratio: '854*480',
        h264: '600',
        h265: '500'
      },
      selectOptinsObj: {
        ratio: getDefaultRatio(),
        h264: getDefaultH264(),
        h265: getDefaultH265()
      }
    }, {
      title: '流畅视频转码参数设置',
      formData: {
        ratio: '480*270',
        h264: '300',
        h265: '200'
      },
      selectOptinsObj: {
        ratio: getDefaultRatio(),
        h264: getDefaultH264(),
        h265: getDefaultH265()
      }
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transcodeParamData.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "transcode-item",
          key: index
        }, [_createVNode(TranscodeParamItem, {
          title: item.title,
          "form-data": item.formData,
          "select-optins-obj": item.selectOptinsObj
        }, null, 8, ["title", "form-data", "select-optins-obj"])]);
      }), 128))]);
    };
  }

});